"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.padsStore = void 0;
const api_1 = require("client/api");
const mobx_1 = require("mobx");
class PadsStore {
    constructor() {
        this.checkConnection = async (socketId) => {
            const response = await api_1.PadEndpoint.getupdatedpad.apiCall(null, {
                socketId
            });
            if (api_1.isError(response)) {
                // return null;
                console.error("Error in checking pad connection", response);
            }
            else {
                // return response;
                this.pad = response.pad;
            }
        };
        this.removePad = async (pad) => {
            const response = await api_1.PadEndpoint.removepad.apiCall(null, {
                pad
            });
            if (api_1.isError(response)) {
                console.error("Error in removing pad", response);
            }
        };
        this.resetPadCache = () => {
            localStorage.removeItem("jwt");
            localStorage.removeItem("name");
            localStorage.removeItem("socketId");
        };
        this.getPadDocuments = async (id, type) => {
            const response = await api_1.PadEndpoint.mobiledocuments.apiCall(null, {
                id: id,
                type: type,
            });
            if (api_1.isError(response)) {
                console.error("Error pulling claim info");
            }
            else {
                return response;
            }
        };
    }
}
__decorate([
    mobx_1.observable
], PadsStore.prototype, "pad", void 0);
__decorate([
    mobx_1.action
], PadsStore.prototype, "checkConnection", void 0);
__decorate([
    mobx_1.action
], PadsStore.prototype, "removePad", void 0);
__decorate([
    mobx_1.action
], PadsStore.prototype, "resetPadCache", void 0);
__decorate([
    mobx_1.action
], PadsStore.prototype, "getPadDocuments", void 0);
exports.padsStore = new PadsStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/pads/store.tsx
// module id = 2444
// module chunks = 0 1